import { PieChartComponent, Text } from '../../../Components'
import { CHART_TOOLTIP_STYLE } from '../../../Components/Charts/chartTheme'
import { formatEuro3Decimals } from '../../../Services/Functions'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const colors = [
  'var(--primary)',
  'var(--success)',
  'var(--warning)',
  'var(--danger)',
  'var(--primary-600)',
  'var(--ai)',
  'var(--primary-700)',
  'var(--ink-700)',
  'var(--ink-500)',
  'var(--ink-400)'
]

export const PieTotalPricingType = ({ data }) => {
  return (
    <PieChartComponent
      legendProps={{ layout: 'vertical', align: 'left', verticalAlign: 'middle' }}
      legend
      data={data || []}
      dataKey="value"
      colors={colors}
      innerRadius="0%"
      outerRadius="100%"
      paddingAngle="0"
      tooltipProps={{
        content: ({ payload: [{ payload: { name = '', value } = {} } = {}] = [] }) => (
          <div style={CHART_TOOLTIP_STYLE}>
            <Text value={name} style={{ fontWeight: 600, color: 'var(--ink-900)' }} />
            <Text
              value={`${t.totale}: ${formatEuro3Decimals(value)}`}
              style={{ color: 'var(--ink-700)' }}
            />
          </div>
        )
      }}
    />
  )
}
